import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
/**
 * The logged-in professor's own profile (includes can_collect_payments).
 * `enabled` lets callers (e.g. the sidebar) skip the request for non-professors,
 * since /professors/me is only available to professor/director roles.
 */
export function useMyProfessor(enabled = true) {
    return useQuery({
        queryKey: ['professor-me'],
        queryFn: () => apiClient('/professors/me'),
        staleTime: 1000 * 60 * 5,
        enabled,
    });
}
//# sourceMappingURL=useMyProfessor.js.map